module.exports = __webpack_public_path__ + "img/people.ac41dae6.svg";